document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('.mfc-card,.mfc-cats a').forEach(el=>{el.addEventListener('mousemove',e=>{const r=el.getBoundingClientRect();el.style.setProperty('--mx',`${e.clientX-r.left}px`);el.style.setProperty('--my',`${e.clientY-r.top}px`);});});});

(function(){
  const customizer=document.querySelector('[data-mfc-customizer]');
  if(customizer){
    const nameInput=customizer.querySelector('[data-input-name]');
    const numberInput=customizer.querySelector('[data-input-number]');
    const colorInput=customizer.querySelector('[data-input-color]');
    const previewName=customizer.querySelector('[data-preview-name]');
    const previewNumber=customizer.querySelector('[data-preview-number]');
    const shirt=customizer.querySelector('[data-shirt]');
    const colors={"Bleu électrique":"#087fff","Blanc":"#ffffff","Or":"#c9971a","Rouge":"#e4172c"};
    const sync=()=>{
      previewName.textContent=(nameInput.value||'TON NOM').slice(0,14);
      previewNumber.textContent=(numberInput.value||'10').replace(/\D/g,'').slice(0,2);
      numberInput.value=previewNumber.textContent==='10' && !numberInput.value ? '' : previewNumber.textContent;
      shirt.style.setProperty('--custom-color',colors[colorInput.value]||'#087fff');
    };
    [nameInput,numberInput,colorInput].forEach(el=>el&&el.addEventListener('input',sync));sync();
  }
})();


(function(){
  const filterWrap = document.querySelector('[data-wc-filters]');
  const grid = document.querySelector('[data-wc-grid]');
  if(!filterWrap || !grid) return;
  const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
  const empty = grid.querySelector('[data-filter-empty]');
  const buttons = Array.from(filterWrap.querySelectorAll('[data-filter]'));
  function applyFilter(filter){
    let visible = 0;
    cards.forEach(card => {
      const tags = (card.getAttribute('data-tags') || '').split(/\s+/);
      const show = filter === 'all' || tags.includes(filter);
      card.hidden = !show;
      if(show) visible += 1;
    });
    if(empty) empty.hidden = visible !== 0;
    buttons.forEach(btn => btn.classList.toggle('is-active', btn.getAttribute('data-filter') === filter));
  }
  buttons.forEach(btn => btn.addEventListener('click', () => applyFilter(btn.getAttribute('data-filter'))));
})();


(function(){
  function money(cents){
    try{return new Intl.NumberFormat('fr-FR',{style:'currency',currency:window.Shopify&&Shopify.currency?Shopify.currency.active:'EUR'}).format((cents||0)/100)}catch(e){return ((cents||0)/100).toFixed(2)+' €'}
  }
  function renderCart(cart){
    const wrap=document.querySelector('[data-cart-items]');
    const total=document.querySelector('[data-cart-total]');
    document.querySelectorAll('.cart span,[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    if(total) total.textContent=money(cart.total_price);
    if(!wrap) return;
    if(!cart.items.length){wrap.innerHTML='<p>Ton panier est vide.</p>'; return;}
    wrap.innerHTML=cart.items.map(item=>`<div class="mfc-cart-item" data-cart-item-key="${item.key}">${item.image?`<img src="${item.image}" alt="${item.product_title}">`:''}<div><a href="${item.url}">${item.product_title}</a>${item.variant_title?`<small>${item.variant_title}</small>`:''}<small>Qté : ${item.quantity}</small><button type="button" data-cart-remove="${item.key}">Retirer</button></div><b>${money(item.final_line_price)}</b></div>`).join('');
  }
  async function refreshCart(){const res=await fetch('/cart.js',{headers:{'Accept':'application/json'}}); const cart=await res.json(); renderCart(cart); return cart;}
  document.addEventListener('click',async e=>{
    if(e.target.closest('[data-cart-close]')) closeCart();
    const remove=e.target.closest('[data-cart-remove]');
    if(remove){e.preventDefault(); await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})}); await refreshCart();}
  });
  document.querySelectorAll('[data-wcp-product]').forEach(root=>{
    const json=root.querySelector('[data-product-json]');
    if(!json) return;
    let variants=[]; try{variants=JSON.parse(json.textContent)}catch(e){}
    const hidden=root.querySelector('[data-variant-id]');
    const price=root.querySelector('[data-wcp-price]');
    const stock=root.querySelector('[data-wcp-stock]');
    const submit=root.querySelector('[data-wcp-submit]');
    const groups=Array.from(root.querySelectorAll('[data-option-index]'));
    const selected=groups.map(g=>g.querySelector('.active')?.dataset.optionValue || g.querySelector('[data-option-value]')?.dataset.optionValue);
    function sync(){
      const variant=variants.find(v=>selected.every((val,i)=>!val || v.options[i]===val));
      if(!variant) return;
      if(hidden) hidden.value=variant.id;
      if(price) price.textContent=money(variant.price);
      if(stock) stock.textContent=variant.available?'● En stock — Expédition 24/48h':'● Rupture de stock';
      if(submit){submit.disabled=!variant.available; submit.textContent=variant.available?'🛒 Ajouter au panier':'Indisponible';}
      if(variant.featured_image && variant.featured_image.src){const img=root.querySelector('[data-wcp-main-image]'); if(img) img.src=variant.featured_image.src;}
    }
    groups.forEach(group=>group.querySelectorAll('[data-option-value]').forEach(btn=>btn.addEventListener('click',()=>{selected[Number(group.dataset.optionIndex)]=btn.dataset.optionValue; group.querySelectorAll('[data-option-value]').forEach(b=>b.classList.toggle('active',b===btn)); sync();})));
    root.querySelectorAll('[data-wcp-thumb]').forEach(btn=>btn.addEventListener('click',()=>{const img=root.querySelector('[data-wcp-main-image]'); if(img) img.src=btn.dataset.wcpThumb;}));
    sync();
  });
})();


document.addEventListener('DOMContentLoaded', function() {
  console.log('Native Shopify cart enabled');
});

// v34: panier Shopify natif, aucun AJAX add-to-cart custom.


// MFC v47: menu mobile accessible
(function(){
  function initMenu(){
    const toggle=document.querySelector('.mfc-menu-toggle');
    const nav=document.querySelector('#MFCMobileMenu');
    if(!toggle || !nav) return;
    const close=()=>{document.body.classList.remove('mfc-menu-open');toggle.setAttribute('aria-expanded','false');};
    const open=()=>{document.body.classList.add('mfc-menu-open');toggle.setAttribute('aria-expanded','true');};
    toggle.addEventListener('click',()=>document.body.classList.contains('mfc-menu-open')?close():open());
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',close));
    document.addEventListener('keydown',e=>{if(e.key==='Escape') close();});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initMenu); else initMenu();
})();


(function(){
  const grid=document.querySelector('[data-wc-grid]');
  const select=document.querySelector('[data-wc-sort]');
  if(!grid||!select) return;
  const original=Array.from(grid.querySelectorAll('[data-product-card]'));
  select.addEventListener('change',()=>{
    const cards=Array.from(grid.querySelectorAll('[data-product-card]'));
    const mode=select.value;
    const sorted=cards.slice().sort((a,b)=>{
      if(mode==='price-asc') return (+a.dataset.price||0)-(+b.dataset.price||0);
      if(mode==='price-desc') return (+b.dataset.price||0)-(+a.dataset.price||0);
      if(mode==='title-asc') return (a.dataset.title||'').localeCompare(b.dataset.title||'');
      if(mode==='title-desc') return (b.dataset.title||'').localeCompare(a.dataset.title||'');
      return original.indexOf(a)-original.indexOf(b);
    });
    sorted.forEach(card=>grid.appendChild(card));
  });
})();
